// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "async-hello-world" + "." + "31e928303a835e9ce15c" + ".js";
};